<div>
  <div class="header-bar">
    <h1>Manage Non-Movement Transactions Report</h1>
  </div>

  <div class="content-container">
    <form (ngSubmit)="search()">
      <div class="ui-g filterPanel">
        <div class="ui-g-12 ui-md-3 ui-lg-3">
          <span class="mt-5">
            <organisation-select-list
              [minTextLength]="1"
              (valueChange)="onOrganisationChange($event)"
            >
            </organisation-select-list>
          </span>
        </div>
        <div class="ui-g-12 ui-md-2 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.from.value"
              name="createdFrom"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>From</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-2 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.to.value"
              name="createdTo"
              dateFormat="dd/mm/yy"
              [minDate]="filterVal.filters.from.value || null"
            ></p-calendar>
            <label>To</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-3 ui-lg-3">
          <span class="md-inputfield filterItem">
            <p-dropdown
              name="transactionTypes"
              [options]="transactionLinePrefixes"
              [(ngModel)]="filterVal.filters.transactionTypeId.value"
              filter="true"
              placeholder="Select a transaction Type"
            ></p-dropdown>
          </span>
        </div>

        <div class="ui-g-12 ui-md-2 ui-lg-2 pull-right">
          <button
            pButton
            type="submit"
            label="Search"
            icon="pi pi-search"
            class="ui-button btn-to-right"
          ></button>
        </div>
      </div>
    </form>

    <p-table
      [columns]="cols"
      [sortField]="filterVal.sortField"
      [sortOrder]="filterVal.sortOrder"
      [value]="page.items"
      [rows]="filterVal.rows"
      [first]="filterVal.first"
      [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
      [paginator]="true"
      [pageLinks]="8"
      [totalRecords]="page.total"
      [lazy]="true"
      (onLazyLoad)="onGridLazyLoad($event)"
      resizableColumns="true"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon
              *ngIf="col.field != 'invoicedDate' && col.field != 'paidOn'"
              [field]="col.field"
              ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"
            ></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr>
          <td
            *ngFor="let col of columns"
            [ngClass]="
              col.field != 'descriptionId' && col.field != 'organisationId' ? 'text-center' : null
            "
          >
            <ng-container *ngIf="col.field == 'amount'">
              <span>{{ rowData[col.field] | currency : 'GBP' : 'symbol' : '1.2-2' }}</span>
            </ng-container>
            <ng-container
              *ngIf="
                col.field == 'createdOn' || col.field == 'invoicedDate' || col.field == 'paidOn'
              "
            >
              <span>{{ rowData[col.field] | datex : 'DD/MM/YYYY' }}</span>
            </ng-container>
            <ng-container *ngIf="col.field == 'organisationId'">
              <span
                ><a href="/app/organisations/{{ rowData.organisation.id }}" target="_blank">{{
                  rowData.organisation.name
                }}</a></span
              >
            </ng-container>
            <ng-container *ngIf="col.field == 'transactionLinePrefixId'">
              <span title="{{ rowData.transactionLinePrefix.description }}">{{
                rowData.transactionLinePrefix.type
              }}</span>
            </ng-container>
            <ng-container *ngIf="col.field == 'descriptionId'">
              <span title="Xero Code"
                >{{ rowData.description.description }} ({{ rowData.description.xeroCode }})</span
              >
            </ng-container>
            <ng-container *ngIf="col.field == 'transactionNumber'">
              <span>{{ rowData[col.field] }}</span>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="ui-g-12">
      <button
        pButton
        type="reset"
        label="Download Report"
        icon="pi pi-download"
        class="ui-button btn-to-right pull-right"
        (click)="downloadReport()"
        [disabled]="!page.items"
      ></button>
    </div>
  </div>
</div>
